import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const PaymentCancel = () => (
  <div className="min-h-screen bg-[#08080a] text-zinc-100 flex items-center justify-center px-4">
    <div className="text-center max-w-md" data-testid="payment-cancel-page">
      <XCircle size={56} className="text-zinc-500 mx-auto mb-6" />
      <h1 className="font-display font-bold text-3xl mb-3">Paiement annulé</h1>
      <p className="text-zinc-400 mb-8">
        Aucun montant n'a été débité. Vous pouvez reprendre le paiement quand vous le souhaitez.
      </p>
      <Link
        to="/"
        className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-semibold px-7 py-3.5 rounded-full transition-colors duration-300"
        data-testid="cancel-back-home-button"
      >
        Retour à l'accueil
      </Link>
    </div>
  </div>
);

export default PaymentCancel;
